import moment from "moment"

const initialState = {
  filters:{
    b_type: '0km',
    car_lot_name: [],
    branch_office_name: [],
    seller_name: []
  },
  filterDate: {
    actual_from: moment().startOf('month').format('YYYY-MM-DD'),
    actual_to: moment().format('YYYY-MM-DD'),
    prev_from: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
    prev_to: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    dateSelected: null
  },
  dashSections : [],
  refreshDate: null,
}
 export default initialState;

  